<template>
  <div>
    <async-items-loader :task="task" :num-items="users.length" class="q-mb-sm">
      No users found.
    </async-items-loader>
    <q-markup-table class="full-width">
      <tbody>
      <tr v-for="user in users" :key="user.id">
        <td>
          <q-checkbox :model-value="isSelected(user.id)" @update:modelValue="toggleSelect(user)" />
        </td>
        <td>
          {{ user.firstName }} {{ user.lastName }}
        </td>
        <td class="text-grey-7">
          {{ user.email }}
        </td>
      </tr>
      </tbody>
    </q-markup-table>
    <mini-pagination v-model="page" :total="total" :per-page="limit" class="q-mt-md" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AsyncItemsLoader from '@/components/item/AsyncItemsLoader.vue';
import MiniPagination from '@/components/pagination/MiniPagination.vue';
import UsersMixin from './UsersMixin';

export default defineComponent({
  mixins: [UsersMixin],
  components: {
    AsyncItemsLoader,
    MiniPagination,
  },
  data(): { limit: number } {
    return {
      limit: 5,
    };
  },
});
</script>
